<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">Home</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">Member Area</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">{{typeName}}</div>
                </div>
            </div>
            <div class="mobiletopbox_bottom" :class="isShowType?'mobiletopbox_bottom_active':''">
                <div class="mobile_type section">
                    <div class="mobile_type_text">
                        <div class="mobile_type_text_left" @click="handleShowType">Category</div>
                        <div class="mobile_type_text_right">
                            <img src="../assets/images/common/more.png" alt="">
                        </div>
                    </div>
                    <div class="mobile_type_box" v-if="isShowType">
                        <div class="mobile_type_box_item" 
                           @click="handleChangeType(item)"
                           :class="typeId==item.id?'mobile_type_box_item_active':''"
                           v-for="(item,i) in typeList" :key="i">
                           <div class="mobile_type_box_item_left"></div>
                           <div class="mobile_type_box_item_right">{{item.typeName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_left hidden-xs-only">
                <div class="news_left_box">
                    <div class="news_left_item"
                    @click="handleChangeType(item)"
                    :class="typeId==item.id?'news_left_item_active':''"
                    v-for="(item,i) in typeList" :key="i">
                        <div class="news_left_item_left">{{item.typeName}}</div>
                        <div class="news_left_item_right">
                            <img v-if="typeId==item.id" src="../assets/images/news/rightArrow_active.png" alt="">
                            <img v-else src="../assets/images/news/rightArrow.png" alt="">
                        </div>
                        <div class="news_left_item_line">
                            <img v-if="typeId==item.id" src="../assets/images/news/line_active.png" alt="">
                            <img v-else src="../assets/images/news/line_none.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="news_left_line">
                    <img src="../assets/images/news/news_left.png" alt="">
                </div>
            </div>
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">Location：</div>
                        <div class="navigation_index" @click="goIndex">Home</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">Member Area</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">{{typeName}}</div>
                    </div>
                </div>
                <!-- 单列 -->
                <div class="news_right_list" v-if="showType==1&&newsList.length>0">
                    <div class="news_right_list_box">
                        <div class="news_right_list_item" v-for="(item,index) in newsList" :key="index">
                            <div class="news_right_list_item_left">
                                <div class="news_right_list_item_left_top">{{item.publishTime?handleTime(1,item.publishTime):""}}</div>
                                <div class="news_right_list_item_left_bottom">{{item.publishTime?handleTime(2,item.publishTime):""}}</div>
                            </div>
                            <div class="news_right_list_item_right">
                                <div class="news_right_list_item_right_top">{{item.title}}</div>
                                <div class="news_right_list_item_right_profile">{{item.profile}}</div>
                                <div class="news_right_list_item_right_button">
                                    <div class="news_right_list_item_right_button_item" @click="handleNewsItem(item)">Details ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 多列 -->
                <div class="news_right_page" v-if="showType==2&&newsList.length>0">
                    <div class="news_right_page_box">
                        <div class="news_right_page_item" @click="handleNewsItem(item)" v-for="(item,index) in newsList" :key="index">
                            <div class="news_right_page_item_top">
                                <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                <img class="none_img" v-else src="../assets/images/index/img_none_english.png" alt="">
                            </div>
                            <div class="news_right_page_item_name">{{item.title}}</div>
                        </div>
                    </div>
                </div>
                <div class="news_right_none" v-if="newsList.length==0">No data available</div>
                <div class="news_right_pagi" v-if="showType==1||showType==2">
                    <el-pagination
                        :current-page="query.current"
                        :page-size="query.pageSize"
                        @current-change="handleCurrentChange"
                        background
                        :total="total"
                        :pager-count="5"
                        layout="prev, pager, next">
                    </el-pagination>
                </div>
                <!-- 详情 -->
                <div class="news_right_bottom" v-if="showType==3&&newsList.length>0">
                    <div class="news_right_bottom_box">
                        <div class="details_content">
                            <div class="details_title">
                                <div class="details_title_top">{{ newsDetails.title }}</div>
                                <div class="details_title_bottom">
                                    <div class="details_title_bottom_left">
                                        PublishTime：
                                        <span>{{newsDetails.publishTime?handleTime(3,newsDetails.publishTime):""}}</span>
                                    </div>
                                    <div class="details_title_bottom_line"></div>
                                    <div class="details_title_bottom_right">
                                        BrowseCount：
                                        <span>{{newsDetails.browseCount?newsDetails.browseCount:0}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="common_artical" >
                                <div v-html="newsDetails.content"></div>
                            </div>
                            <div class="file" v-if="newsDetails.newsFileList && newsDetails.newsFileList.length > 0">
                                <div class="file_box">
                                    <div class="file_left">Files：</div>
                                    <div class="file_right">
                                        <div class="file_right_item" v-for="(item, i) in newsDetails.newsFileList" :key="i">
                                            <a :href="baseUrl + item.fileUrl">{{ item.fileName }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsTypeList, newsList,newsDetails,newsBrowse } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            typeId: this.$route.query.type?this.$route.query.type:'',
            typeName:'',
            showType:null,//1为单列,2为多列，3为详情
            query: {
                current: this.$route.query.current?Number(this.$route.query.current):1,
                pageSize: null,
                newsType: this.$route.query.type?this.$route.query.type:'',
                model:7,
                lang:2
            },
            newsList: [],
            total: 0,
            typeList:[],
            newsDetails: '',

            isShowType:false
        }
    },
    created() {
        this.getNewsType(7)
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        async getNewsType(num) {
            let res = await newsTypeList(
                {
                    model:num,
                    lang:2
                }
            )
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.typeList = res.data.records
            if(this.typeList.length > 0) {
                if(this.typeId) {
                    this.showType = this.typeList.find(item => item.id == this.typeId).showType
                    this.typeName = this.typeList.find(item => item.id == this.typeId).typeName
                } else {
                    this.typeId = this.typeList[0].id
                    this.query.newsType = this.typeList[0].id
                    this.typeName = this.typeList[0].typeName
                    this.showType = this.typeList[0].showType
                }
            }
            this.handleShowWay()
        },
        // 通过当前的type判断展示方式
        handleShowWay() {
            if(this.showType == 1) {
                this.query.pageSize = 8
            } else if(this.showType == 2) {
                this.query.pageSize = 12
            } else if(this.showType == 3) {
                this.query.pageSize = -1
            }
            this.getNewsList()
        },
        // 获取新闻列表
        async getNewsList() {
            this.loading = true // loading start
            let res = await newsList(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.newsList = res.data.records
            this.total = res.data.total
            if(this.newsList.length > 0) {
                if(this.showType==3) {
                    let id = this.newsList[0].id
                    this.getNewsDetails(id)
                }
            }
            setTimeout(() => {
                this.restoreScrollPosition()
            }, 500);
        },
        handleCurrentChange(data) {
            this.query.current = data
            this.getNewsList()
            this.getScroll()
        },
        // 获取新闻详情
        async getNewsDetails(id) {
            let res = await newsDetails(id)
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            if (res.length !== 0) {
                this.newsDetails = res.data
            } else {
                this.newsDetails = ''
            }
            this.getNewsBrowse(id)
        },
        async getNewsBrowse(id) {
            const res = await newsBrowse(id)
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
        },
        handleChangeType(item) {
            this.typeId = item.id
            this.query.newsType = item.id
            this.typeName = item.typeName
            this.showType = item.showType
            this.query.current = 1
            // this.handleShowWay()
            // this.getScroll()
            window.location.href = '/#/member_en?type=' + item.id
        },
        handleNewsItem(item) {
            if(item.link) {
                window.open(item.link, '_blank');
            } else {
                this.$router.push({name: 'details_en', params: { name: 'member_en', type: item.newsType, id: item.id,current:this.query.current } })
            }
        },
        handleTime(num,time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = ''
                if(num==1) {
                    // 年月
                    timeStr = year+'-'+month
                    return timeStr;
                } else if(num==2) {
                    // 日
                    timeStr = day
                    return timeStr;
                }else if(num==3) {
                    // 年月日
                    timeStr = year+'-'+month+'-'+day
                    return timeStr;
                }
            }
        },
        restoreScrollPosition() {
            const scrollPosition = window.sessionStorage.getItem('scrollPosition');
            if (scrollPosition) {
                // 恢复滚动位置
                $('html, body').animate({scrollTop: scrollPosition}, 100)
                setTimeout(() => {
                    window.sessionStorage.removeItem('scrollPosition'); // 清除存储的滚动位置，防止重复使用
                }, 500);
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
        goIndex() {
            this.$router.push('/index_en')
        },
        handleShowType() {
            this.isShowType = !this.isShowType
        }
    },
    beforeRouteLeave(to, from, next) {
        if(to.name == "details_en") {
            window.sessionStorage.setItem('scrollPosition', window.scrollY);
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 60px 0;
    .news_box {
        display: flex;
        .news_left {
            width: 288px;
            margin-right: 30px;
            position: relative;
            .news_left_box {
                padding: 24px 20px 20px 20px;
                background-color: #ffffff;
                .news_left_item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;
                    padding: 0 20px 0 25px;
                    background-color: #F6F9FF;
                    margin-bottom: 10px;
                    height: 56px;
                    cursor: pointer;
                    position: relative;
                    .news_left_item_left {
                        width: calc(100% - 12px);
                    }
                    .news_left_item_right {
                        width: 12px;
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    .news_left_item_line {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 0;
                        width: 6px;
                        height: 24px;
                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 6px;
                            height: 24px;
                        }
                    }
                }
                .news_left_item_active {
                    background-color: #0085D0;
                    color: #ffffff;
                }
                .news_left_item:last-child {
                    margin-bottom: 0;
                }
            }
            .news_left_line {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 4px;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 4px;
                }
            }
        }
        .news_right {
            width: calc(100% - 288px - 30px);
            .news_right_top {
                border-bottom: 1px solid #E3E3E3;
            }
            .news_right_none {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #ffffff;
                min-height: 200px;
                font-size: 16px;
                margin-bottom: 60px;
            }
            .news_right_list {
                .news_right_list_box {
                    padding: 20px 0 60px 0;
                    .news_right_list_item {
                        padding: 30px;
                        margin-bottom: 20px;
                        background-color: #ffffff;
                        border-radius: 12px;
                        display: flex;
                        justify-content: space-between;
                        .news_right_list_item_left {
                            width: 84px;
                            height: 84px;
                            background-color: #EBEFF6;
                            border-radius: 12px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            color: #4E5F77;
                            margin-right: 30px;
                            .news_right_list_item_left_top {
                                font-size: 14px;
                            }
                            .news_right_list_item_left_bottom {
                                font-size: 28px;
                                font-weight: bold;
                                margin-top: -5px;
                            }
                        }
                        .news_right_list_item_right {
                            width: calc(100% - 30px - 85px);
                            .news_right_list_item_right_top {
                                color: #000000;
                                font-size: 20px;
                                font-weight: bold;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                            .news_right_list_item_right_profile {
                                font-size: 16px;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                line-height: 1.8;
                                color: #787878;
                                margin: 20px 0 25px 0;
                            }
                            .news_right_list_item_right_button {
                                .news_right_list_item_right_button_item {
                                   width: 136px;
                                    height: 42px;
                                    background: #ffffff;
                                    border: 1px solid #ebeff6;
                                    border-radius: 6px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    font-size: 16px;
                                    color: #4E5F77;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .news_right_list_item:last-child {
                        margin-bottom: 0;
                    }
                    .news_right_list_item:hover {
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        .news_right_list_item_right {
                            .news_right_list_item_right_top {
                                color: #0085D0;
                                text-decoration: underline;
                                text-underline-offset: 3px;
                            }
                            .news_right_list_item_right_button {
                                .news_right_list_item_right_button_item {
                                    background: #0085d0;
                                    border: 1px solid #ebeff6;
                                    color: #ffffff;
                                }
                            }
                        }

                    }
                }
            }
            .news_right_page {
                .news_right_page_box {
                    padding: 20px 0 60px 0;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    .news_right_page_item {
                        width: 280px;
                        background: #ffffff;
                        border-radius: 12px;
                        padding: 10px 10px 0 10px;
                        cursor: pointer;
                        .news_right_page_item_top {
                            width: 100%;
                            height: 260px;
                            border-radius: 6px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            overflow: hidden;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                            .none_img {
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }
                        .news_right_page_item_name {
                            text-align: center;
                            font-size: 18px;
                            padding: 20px;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                    }
                    .news_right_page_item:hover {
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        .news_right_page_item_name {
                            color: #0085D0;
                            text-decoration: underline;
                            text-underline-offset: 3px;
                        }
                    }
                }
            }
            .news_right_bottom {
                background-color: #ffffff;
                .news_right_bottom_box {
                    padding: 30px;
                    .details_content {
                        .details_title {
                            padding-bottom: 25px;
                            border-bottom: 1px dashed #DCDCDC;
                            .details_title_top {
                                font-size: 24px;
                                line-height: 36px;
                                font-weight: bold;
                                text-align: center;
                                margin-bottom: 20px;
                            }
                            .details_title_bottom {
                                font-size: 16px;
                                color: #787878;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .details_title_bottom_left {
                                    span {
                                        color: #000000;
                                    }
                                }
                                .details_title_bottom_line {
                                    width: 1px;
                                    height: 15px;
                                    background-color: #000000;
                                    margin: 0 20px;
                                }
                                .details_title_bottom_right {
                                    span {
                                        color: #000000;
                                    }
                                }
                            }
                        }
                        .common_artical {
                            padding: 25px 0;
                            border-bottom: 1px dashed #DCDCDC;
                        }
                        .file {
                            padding: 25px 0;
                            border-bottom: 1px dashed #DCDCDC;
                            .file_box {
                                display: flex;
                                .file_left {
                                    width: 80px;
                                    font-size: 16px;
                                }
                                .file_right {
                                    width: calc(100% - 80px);
                                    .file_right_item {
                                        margin-bottom: 5px;
                                        a {
                                            font-size: 16px;
                                        }
                                    }
                                    .file_right_item:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: .3rem 0 .6rem 0;
        .news_box {
            flex-direction: column;
            .news_right {
                width: 100%;
                .news_right_top {
                    border-bottom: 1px solid #E3E3E3;
                }
                .news_right_none {
                    min-height: 3rem;
                    font-size: 0.3rem;
                    margin-bottom: 0.6rem;
                    margin-top: 0.2rem;
                }
                .news_right_list {
                    .news_right_list_box {
                        padding: 0.2rem 0 0.6rem 0;
                        .news_right_list_item {
                            padding: 0.2rem;
                            margin-bottom: 0.2rem;
                            border-radius: 0.12rem;
                            .news_right_list_item_left {
                                width: 1.4rem;
                                height: 1.4rem;
                                border-radius: 0.1rem;
                                margin-right: 0.2rem;
                                .news_right_list_item_left_top {
                                    font-size: 0.26rem;
                                }
                                .news_right_list_item_left_bottom {
                                    font-size: 0.4rem;
                                    margin-top: -0.05rem;
                                }
                            }
                            .news_right_list_item_right {
                                width: calc(100% - 0.2rem - 1.4rem);
                                .news_right_list_item_right_top {
                                    font-size: 0.3rem;
                                }
                                .news_right_list_item_right_profile {
                                    font-size: 0.28rem;
                                    line-height: 1.6;
                                    margin: 0.2rem 0 ;
                                }
                                .news_right_list_item_right_button {
                                    .news_right_list_item_right_button_item {
                                        width: 2.3rem;
                                        height: 0.7rem;
                                        border-radius: 0.15rem;
                                        font-size: 0.28rem;
                                    }
                                }
                            }
                        }
                    }
                }
                .news_right_page {
                    .news_right_page_box {
                        padding: 0.2rem 0 0.6rem 0;
                        gap: 0.2rem;
                        .news_right_page_item {
                            width: 3.43rem;
                            border-radius: 0.12rem;
                            padding: 0.2rem 0.2rem 0.2rem 0.2rem;
                            .news_right_page_item_top {
                                width: 100%;
                                height: 3rem;
                                border-radius: 0.1rem;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                                .none_img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                }
                            }
                            .news_right_page_item_name {
                                font-size: 0.3rem;
                                padding: 0.2rem 0 0 0;
                            }
                        }
                    }
                }
                .news_right_bottom {
                    background-color: #ffffff;
                    .news_right_bottom_box {
                        padding: 0.3rem 0.2rem;
                        .details_content {
                            .details_title {
                                padding-bottom: 0.3rem;
                                .details_title_top {
                                    font-size: 0.35rem;
                                    line-height: 1.5;
                                    margin-bottom: .2rem;
                                }
                                .details_title_bottom {
                                    font-size: 0.26rem;
                                    .details_title_bottom_line {
                                        width: 0.02rem;
                                        height: 0.28rem;
                                        margin: 0 0.2rem;
                                    }
                                }
                            }
                            .common_artical {
                                padding: 0.3rem 0;
                            }
                            .file {
                                padding: 0.3rem 0;
                                .file_box {
                                    .file_left {
                                        width: 1.4rem;
                                        font-size: 0.28rem;
                                    }
                                    .file_right {
                                        width: calc(100% - 1.4rem);
                                        .file_right_item {
                                            margin-bottom: 0.1rem;
                                            a {
                                                font-size: 0.28rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>